import {
  AlertCircle,
  BarChart3,
  Calculator,
  ChevronDown,
  ChevronUp,
  CreditCard,
  DollarSign,
  FileText,
  Play,
  Settings,
  Target,
  Users,
} from "lucide-react";
import { useCallback, useState } from "react";
import BotaoRelatorio from "../components/BotaoRelatorio";

const SistemaOrcamento = () => {
  const [expandedSections, setExpandedSections] = useState({
    indicadores: true,
    despesas: true,
    outrosCustos: true,
  });

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const [centroCusto, setCentroCusto] = useState("1.05.01.02.001");
  const [rateioGastos, setRateioGastos] = useState(25);
  const [loading, setLoading] = useState(false);
  const [, setLoadingItensInvestimento] = useState(false);
  const [dadosCarregados, setDadosCarregados] = useState(false);
  const [, setDadosProcon] = useState({});

  // Constantes das contas do Procon
  const CONTA_PESSOAL = "CONTA_PESSOAL";
  const CONTA_PESSOAL_DOCENTE = "CONTA_PESSOAL_DOCENTE";
  const CONTA_ENCARGOS_DOCENTES = "CONTA_ENCARGOS_DOCENTES";
  const CONTA_PESSOAL_ADMIN = "CONTA_PESSOAL_ADMIN";
  const CONTA_ENCARGOS_ADMIN = "CONTA_ENCARGOS_ADMIN";
  const CONTA_DESPESAS_GERAIS = "CONTA_DESPESAS_GERAIS";
  const CONTA_MATERIAL = "CONTA_MATERIAL";
  const CONTA_CONSERVACAO = "CONTA_CONSERVACAO";
  const CONTA_SERVICOS_TERCEIROS = "CONTA_SERVICOS_TERCEIROS";
  const CONTA_SERVICOS_PUBLICOS = "CONTA_SERVICOS_PUBLICOS";
  const CONTA_ISS = "CONTA_ISS";
  const CONTA_OUTRAS_TRIBUTARIAS = "CONTA_OUTRAS_TRIBUTARIAS";
  const CONTA_ALUGUEIS = "CONTA_ALUGUEIS";
  const CONTA_DEPRECIACAO = "CONTA_DEPRECIACAO";
  const CONTA_OUTRAS_DESPESAS = "CONTA_OUTRAS_DESPESAS";
  const CONTA_PRO_LABORE = "CONTA_PRO_LABORE";
  const CONTA_VALOR_LOCATIVO = "CONTA_VALOR_LOCATIVO";
  const CONTA_CONTRIB_SOCIAIS = "CONTA_CONTRIB_SOCIAIS";
  const CONTA_PIS_PASEP = "CONTA_PIS_PASEP";
  const CONTA_COFINS = "CONTA_COFINS";
  const CONTA_ALUNOS_PAGANTES = "CONTA_ALUNOS_PAGANTES";
  const CONTA_ALUNOS_NAO_PAGANTES = "CONTA_ALUNOS_NAO_PAGANTES";
  const CONTA_ULTIMA_MENSALIDADE = "CONTA_ULTIMA_MENSALIDADE";
  const CONTA_MENSALIDADE_REAJUSTE = "CONTA_MENSALIDADE_REAJUSTE";
  const CONTA_LOCAL = "CONTA_LOCAL";
  const CONTA_DATA = "CONTA_DATA";
  const CONTA_NUM_FUNCIONARIOS = "CONTA_NUM_FUNCIONARIOS";
  const CONTA_NUM_PROFESSORES = "CONTA_NUM_PROFESSORES";
  const CONTA_CARGA_HORARIA = "CONTA_CARGA_HORARIA";
  const CONTA_FATURAMENTO_TOTAL = "CONTA_FATURAMENTO_TOTAL";

  const PpCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
  const PpCODFILIAL = localStorage.getItem("PCODFILIAL");
  const PpANO = localStorage.getItem("selectedYear");

    // ✅ NOVOS ESTADOS PARA O MODAL DE LOADING DOS RELATÓRIOS
    const [relatorioLoading, setRelatorioLoading] = useState(false);
    const [relatorioTipo, setRelatorioTipo] = useState("");
    const [relatorioNome, setRelatorioNome] = useState("");
    const [relatorioProgresso, setRelatorioProgresso] = useState(0);
    const [relatorioMensagem, setRelatorioMensagem] = useState("");
    const [relatorioResultado, setRelatorioResultado] = useState(null);
    const [relatorioInterval, setRelatorioInterval] = useState(null);



  // ✅ DADOS VAZIOS - SÓ CARREGAM DEPOIS DO PROCON
  const [indicadoresGlobais, setIndicadoresGlobais] = useState({
    numFuncionarios: 0,
    numProfessores: 0,
    cargaHoraria: 0,
    faturamentoBase: 0,
    faturamentoReajuste: 0,
    faturamentoAplicado: 0,
    // ✅ NOVOS CAMPOS ADICIONADOS
    alunosPagantes: 0,
    alunosNaoPagantes: 0,
    ultimaMensalidade: 0,
    mensalidadeReajuste: 0,
    local: "",
    data: new Date().toLocaleDateString("pt-BR"),
    // ✅ IDS DOS RELATÓRIOS PARA OS CAMPOS EDITÁVEIS (MESMA LÓGICA DAS DESPESAS)
    alunosPagantesId: null,
    alunosNaoPagantesId: null,
    ultimaMensalidadeId: null,
    mensalidadeReajusteId: null,
  });

  // ✅ ESTRUTURA VAZIA DAS DESPESAS - COM ID_RELATORIO
  const [despesas, setDespesas] = useState([
    {
      id: 1,
      grupo: "1.0",
      description: "PESSOAL",
      isHeader: true,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 2,
      grupo: "1.1",
      description: "Pessoal Docente",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 3,
      grupo: "1.2",
      description: "Encargos Sociais Docentes",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 4,
      grupo: "1.3",
      description: "Pessoal Técnico e Administrativo",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 5,
      grupo: "1.4",
      description: "Encargos Sociais Administrativos",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 6,
      grupo: "2.0",
      description: "DESPESAS GERAIS E ADMINISTRATIVAS",
      isHeader: true,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 7,
      grupo: "2.1",
      description: "Despesas com Material",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 8,
      grupo: "2.2",
      description: "Conservação e Manutenção",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 9,
      grupo: "2.3",
      description: "Serviços de Terceiros",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 10,
      grupo: "2.4",
      description: "Serviços Públicos",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 11,
      grupo: "2.5",
      description: "Imposto sobre Serviços (ISS)",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 12,
      grupo: "2.6",
      description: "Outras Despesas Tributárias",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 13,
      grupo: "2.7",
      description: "Aluguéis",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 14,
      grupo: "2.8",
      description: "Depreciação",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 15,
      grupo: "2.9",
      description: "Outras Despesas",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
  ]);

  // ✅ ESTRUTURA VAZIA DOS OUTROS CUSTOS - COM ID_RELATORIO
  const [outrosCustos, setOutrosCustos] = useState([
    {
      id: 16,
      grupo: "3.0",
      description: "SUBTOTAL (1 + 2)",
      isHeader: true,
      isSpecial: true,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 17,
      grupo: "4.0",
      description: "Pró-Labore",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 18,
      grupo: "5.0",
      description: "Valor Locativo",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 19,
      grupo: "6.0",
      description: "SUBTOTAL (4 + 5)",
      isHeader: true,
      isSpecial: true,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 20,
      grupo: "7.0",
      description: "Contribuições Sociais",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 21,
      grupo: "7.1",
      description: "PIS/PASEP",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 22,
      grupo: "7.2",
      description: "COFINS",
      isHeader: false,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
    {
      id: 23,
      grupo: "8.0",
      description: "TOTAL GERAL",
      isHeader: true,
      isSpecial: true,
      baseValue: 0,
      adjustmentPercent: 0,
      appliedValue: 0,
      idRelatorio: null,
    },
  ]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const getBadgeColor = (index, value = 0) => {
    if (value === 0) return "danger";
    if (value > 1000000) return "success";
    if (value < 100000) return "warning";
    const colors = ["primary", "info", "secondary", "dark", "success"];
    return colors[index % colors.length];
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // ✅ NOVA FUNÇÃO PARA ATUALIZAR INDICADORES GLOBAIS NO BANCO - ValoresProconGlobal
  // ✅ USANDO MESMA LÓGICA DE updateDespesaPercent COM ID_RELATORIO
  const updateIndicadorGlobal = async (itemId, novoValor) => {
    try {
      // ✅ ENCONTRAR O ITEM DO INDICADOR GLOBAL BASEADO NO ID
      const indicadoresItems = [
        {
          id: "alunosPagantes",
          field: "alunosPagantes",
          idRelatorio: indicadoresGlobais.alunosPagantesId || null,
        },
        {
          id: "alunosNaoPagantes",
          field: "alunosNaoPagantes",
          idRelatorio: indicadoresGlobais.alunosNaoPagantesId || null,
        },
        {
          id: "ultimaMensalidade",
          field: "ultimaMensalidade",
          idRelatorio: indicadoresGlobais.ultimaMensalidadeId || null,
        },
        {
          id: "mensalidadeReajuste",
          field: "mensalidadeReajuste",
          idRelatorio: indicadoresGlobais.mensalidadeReajusteId || null,
        },
      ];

      const item = indicadoresItems.find((item) => item.id === itemId);
      if (!item) {
        console.warn("Item de indicador não encontrado:", itemId);
        return;
      }

      // ✅ PREPARAR DADOS PARA ENVIO
      const token = localStorage.getItem("authToken");
      if (!token) {
        alert("❌ Token de autenticação não encontrado");
        return;
      }

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ USAR ID_RELATORIO SE EXISTIR, SENÃO USAR O ID DO ITEM (MESMA LÓGICA DE updateDespesaPercent)
      const idParaEnvio = item.idRelatorio || itemId;

      // ✅ DADOS PARA A API
      const dadosAtualizacao = {
        ID: idParaEnvio, // ✅ USAR ID_RELATORIO CORRETO (MESMA LÓGICA)
        VALORPROCON: novoValor, // ✅ VALOR DIRETO (NÃO PERCENTUAL)
      };

      console.log(
        "🔍 Dados para atualização (Indicadores Globais):",
        dadosAtualizacao
      );

      // ✅ CHAMAR A API PARA GRAVAR NO BANCO
      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/ValoresProconGlobal`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(dadosAtualizacao),
        }
      );

      const result = await response.json();
      console.log("🔍 Resposta do servidor (ValoresProconGlobal):", result);

      if (result.success) {
        // ✅ SE DEU SUCESSO, ATUALIZAR O ESTADO LOCAL
        setIndicadoresGlobais((prev) => {
          const updated = { ...prev, [item.field]: novoValor };

          // ✅ ATUALIZAR ID_RELATORIO SE RETORNADO PELA API (MESMA LÓGICA)
          if (result.id_relatorio) {
            updated[item.field + "Id"] = result.id_relatorio;
          }

          // ✅ RECALCULAR FATURAMENTO APLICADO SE NECESSÁRIO
          if (
            item.field === "faturamentoBase" ||
            item.field === "faturamentoReajuste"
          ) {
            updated.faturamentoAplicado =
              updated.faturamentoBase * updated.faturamentoReajuste;
          }

          return updated;
        });

        console.log("✅ Indicador global atualizado com sucesso!");
      } else {
        // ✅ SE DEU ERRO, MOSTRAR MENSAGEM
        alert(
          `❌ Erro ao atualizar indicador: ${
            result.message || "Erro desconhecido"
          }`
        );
        console.error("❌ Erro na resposta:", result);
      }
    } catch (error) {
      // ✅ TRATAR ERROS DE CONEXÃO
      console.error("❌ Erro ao atualizar indicador no banco:", error);
      alert(`❌ Erro de conexão: ${error.message}`);
    }
  };

  // ✅ FUNÇÃO PARA ATUALIZAR PERCENTUAL DE DESPESAS - USANDO ID_RELATORIO
  const updateDespesaPercent = async (itemId, newPercent) => {
    try {
      // ✅ ENCONTRAR O ITEM PARA OBTER OS DADOS NECESSÁRIOS
      const item = despesas.find((item) => item.id === itemId);
      if (!item || item.isHeader) {
        console.warn("Item não encontrado ou não editável:", itemId);
        return;
      }

      // ✅ CALCULAR O NOVO VALOR COM O PERCENTUAL
      const newAppliedValue = item.baseValue * (1 + newPercent / 100);

      // ✅ PREPARAR DADOS PARA ENVIO
      const token = localStorage.getItem("authToken");
      if (!token) {
        alert("❌ Token de autenticação não encontrado");
        return;
      }

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ USAR ID_RELATORIO SE EXISTIR, SENÃO USAR O ID DO ITEM
      const idParaEnvio = item.idRelatorio || itemId;

      // ✅ DADOS PARA A API
      const dadosAtualizacao = {
        ID: idParaEnvio, // ✅ USAR ID_RELATORIO CORRETO
        PERCENTUALAJUS: newPercent, // Percentual de reajuste
        VALORPROCON: newAppliedValue, // Valor calculado com reajuste
      };

      console.log("🔍 Dados para atualização (Despesas):", dadosAtualizacao);

      // ✅ CHAMAR A API PARA GRAVAR NO BANCO
      const response = await fetch(`${API_BASE_URL}/SQlCustom/ValoresProcon`, {
        method: "POST",
        headers,
        body: JSON.stringify(dadosAtualizacao),
      });

      const result = await response.json();
      console.log(
        "🔍 Resposta do servidor (ValoresProcon - Despesas):",
        result
      );

      if (result.success) {
        // ✅ SE DEU SUCESSO, ATUALIZAR O ESTADO LOCAL
        setDespesas((prev) =>
          prev.map((prevItem) => {
            if (prevItem.id === itemId && !prevItem.isHeader) {
              const updatedItem = {
                ...prevItem,
                adjustmentPercent: newPercent,
                appliedValue: newAppliedValue,
                // ✅ ATUALIZAR ID_RELATORIO SE RETORNADO PELA API
                idRelatorio:
                  result.id_relatorio || prevItem.idRelatorio || idParaEnvio,
              };
              return updatedItem;
            }
            return prevItem;
          })
        );

        console.log("✅ Despesa atualizada com sucesso!");
      } else {
        // ✅ SE DEU ERRO, MOSTRAR MENSAGEM
        alert(
          `❌ Erro ao atualizar despesa: ${
            result.message || "Erro desconhecido"
          }`
        );
        console.error("❌ Erro na resposta:", result);
      }
    } catch (error) {
      // ✅ TRATAR ERROS DE CONEXÃO
      console.error("❌ Erro ao atualizar despesa no banco:", error);
      alert(`❌ Erro de conexão: ${error.message}`);
    }
  };

  // ✅ FUNÇÃO PARA ATUALIZAR PERCENTUAL DE OUTROS CUSTOS - USANDO ID_RELATORIO
  const updateOutrosCustosPercent = async (itemId, newPercent) => {
    try {
      // ✅ ENCONTRAR O ITEM PARA OBTER OS DADOS NECESSÁRIOS
      const item = outrosCustos.find((item) => item.id === itemId);
      if (!item || item.isHeader || item.isSpecial) {
        console.warn("Item não encontrado ou não editável:", itemId);
        return;
      }

      // ✅ CALCULAR O NOVO VALOR COM O PERCENTUAL
      const newAppliedValue = item.baseValue * (1 + newPercent / 100);

      // ✅ PREPARAR DADOS PARA ENVIO
      const token = localStorage.getItem("authToken");
      if (!token) {
        alert("❌ Token de autenticação não encontrado");
        return;
      }

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ✅ USAR ID_RELATORIO SE EXISTIR, SENÃO USAR O ID DO ITEM
      const idParaEnvio = item.idRelatorio || itemId;

      // ✅ DADOS PARA A API
      const dadosAtualizacao = {
        ID: idParaEnvio, // ✅ USAR ID_RELATORIO CORRETO
        PERCENTUALAJUS: newPercent, // Percentual de reajuste
        VALORPROCON: newAppliedValue, // Valor calculado com reajuste
      };

      console.log(
        "🔍 Dados para atualização (Outros Custos):",
        dadosAtualizacao
      );

      // ✅ CHAMAR A API PARA GRAVAR NO BANCO
      const response = await fetch(`${API_BASE_URL}/SQlCustom/ValoresProcon`, {
        method: "POST",
        headers,
        body: JSON.stringify(dadosAtualizacao),
      });

      const result = await response.json();
      console.log("🔍 Resposta do servidor (ValoresProcon):", result);

      if (result.success) {
        // ✅ SE DEU SUCESSO, ATUALIZAR O ESTADO LOCAL
        setOutrosCustos((prev) =>
          prev.map((prevItem) => {
            if (
              prevItem.id === itemId &&
              !prevItem.isHeader &&
              !prevItem.isSpecial
            ) {
              const updatedItem = {
                ...prevItem,
                adjustmentPercent: newPercent,
                appliedValue: newAppliedValue,
                // ✅ ATUALIZAR ID_RELATORIO SE RETORNADO PELA API
                idRelatorio:
                  result.id_relatorio || prevItem.idRelatorio || idParaEnvio,
              };
              return updatedItem;
            }
            return prevItem;
          })
        );

        console.log("✅ Outros custos atualizados com sucesso!");
      } else {
        // ✅ SE DEU ERRO, MOSTRAR MENSAGEM
        alert(
          `❌ Erro ao atualizar valor: ${result.message || "Erro desconhecido"}`
        );
        console.error("❌ Erro na resposta:", result);
      }
    } catch (error) {
      // ✅ TRATAR ERROS DE CONEXÃO
      console.error("❌ Erro ao atualizar valor no banco:", error);
      alert(`❌ Erro de conexão: ${error.message}`);
    }
  };

  const totalDespesas = despesas.reduce(
    (sum, item) => (item.isHeader ? sum : sum + item.appliedValue),
    0
  );

  const totalOutrosCustos = outrosCustos.reduce(
    (sum, item) =>
      item.isHeader || item.isSpecial ? sum : sum + item.appliedValue,
    0
  );

  // ✅ FUNÇÃO PARA GRAVAR DADOS NO BANCO (ProconCriaDados)
  const ProconCriaDados = async () => {
    setLoading(true);
    try {
      const ANO = localStorage.getItem("selectedYear") || "2025";
      const CODCOLIGADA = localStorage.getItem("PCODCOLIGADA") || "1";
      const CODFILIAL = localStorage.getItem("PCODFILIAL") || "1";
      const CODCCUSTO = centroCusto;
      const VALORRATEIO = rateioGastos;
      const token = localStorage.getItem("authToken");

      console.log("🔍 Dados auth para efetivação:", {
        CODFILIAL,
        CODCOLIGADA,
        ANO,
        CODCCUSTO,
        VALORRATEIO,
      });

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const dadosEfetivacao = {
        CODFILIAL,
        CODCOLIGADA,
        ANO,
        CODCCUSTO,
        VALORRATEIO,
      };

      const payload = { dadosEfetivacao };
      console.log(
        "🔍 Payload completo para efetivação:",
        JSON.stringify(payload)
      );

      const response = await fetch(`${API_BASE_URL}/SQlCustom/ProconCarrega`, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      console.log("🔍 Resposta do servidor (Procon):", result);
      if (result.success) {
        alert("🔄 Procon atualizado com sucesso!");
        // ✅ APÓS GRAVAR, CARREGAR OS DADOS ATUALIZADOS
        await carregarItensPronco(centroCusto, "orcamento", ANO);
        setDadosCarregados(true); // ✅ MARCAR QUE DADOS FORAM CARREGADOS
      } else {
        alert(
          `❌ Erro ao carregar dados do Procon: ${
            result.message || "Erro desconhecido"
          }`
        );
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados do Procon:", error);
      alert(`❌ Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNÇÃO AJUSTADA PARA CARREGAR DADOS REAIS DO BANCO COM PERCENTUAIS E IDS
  const carregarItensPronco = useCallback(
    async (centroCusto, natureza, ano) => {
      try {
        setLoadingItensInvestimento(true);
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA") || "1";
        const PCODFILIAL = localStorage.getItem("PCODFILIAL") || "1";

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // ✅ WHERE CLAUSE PARA BUSCAR DADOS DO CENTRO DE CUSTO
        let whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${ano}' AND CENTROCUSTO = '${centroCusto}' `;

        console.log("🔍 Carregando itens com WHERE:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_Man_ORC_0018/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado completo do banco:", result);

        if (result.success && result.data) {
          // ✅ MAPEAR DADOS USANDO A ESTRUTURA REAL DO BANCO
          const dadosMapeados = {};

          // ✅ NOVO: MAPEAR DADOS DE PERCENTUAIS E IDS
          const dadosPercentuais = {};

          // ✅ NOVO: MAPEAR DADOS DE IDS DOS INDICADORES GLOBAIS
          const dadosIndicadoresIds = {};

          // ✅ INICIALIZAR ESTRUTURA
          dadosMapeados[CONTA_PESSOAL] = 0;
          dadosMapeados[CONTA_PESSOAL_DOCENTE] = 0;
          dadosMapeados[CONTA_ENCARGOS_DOCENTES] = 0;
          dadosMapeados[CONTA_PESSOAL_ADMIN] = 0;
          dadosMapeados[CONTA_ENCARGOS_ADMIN] = 0;
          dadosMapeados[CONTA_DESPESAS_GERAIS] = 0;
          dadosMapeados[CONTA_MATERIAL] = 0;
          dadosMapeados[CONTA_CONSERVACAO] = 0;
          dadosMapeados[CONTA_SERVICOS_TERCEIROS] = 0;
          dadosMapeados[CONTA_SERVICOS_PUBLICOS] = 0;
          dadosMapeados[CONTA_ISS] = 0;
          dadosMapeados[CONTA_OUTRAS_TRIBUTARIAS] = 0;
          dadosMapeados[CONTA_ALUGUEIS] = 0;
          dadosMapeados[CONTA_DEPRECIACAO] = 0;
          dadosMapeados[CONTA_OUTRAS_DESPESAS] = 0;
          dadosMapeados[CONTA_PRO_LABORE] = 0;
          dadosMapeados[CONTA_VALOR_LOCATIVO] = 0;
          dadosMapeados[CONTA_CONTRIB_SOCIAIS] = 0;
          dadosMapeados[CONTA_PIS_PASEP] = 0;
          dadosMapeados[CONTA_COFINS] = 0;
          dadosMapeados[CONTA_NUM_FUNCIONARIOS] = 0;
          dadosMapeados[CONTA_NUM_PROFESSORES] = 0;
          dadosMapeados[CONTA_CARGA_HORARIA] = 0;
          dadosMapeados[CONTA_FATURAMENTO_TOTAL] = 0;

          // ✅ PROCESSAR DADOS DO BANCO COM ESTRUTURA REAL
          result.data.forEach((item) => {
            const contaTipo = item.CONTAS || "";
            const valor = parseFloat(item.VALORRATEIO || 0);
            const valorFunc = parseFloat(item.VALORCALCULO || 0);

            // ✅ NOVO: CAPTURAR DADOS DE PERCENTUAIS E IDS
            const idRelatorio = item.ID_RELATORIO || item.ID || null;
            const percentualAjus = parseFloat(item.PERCENTUALAJUS || 0);
            const valorProcon = parseFloat(item.VALORPROCON || 0);

            console.log(
              `🔍 Processando: ${contaTipo} = ${valor} | ID: ${idRelatorio} | %: ${percentualAjus} | Valor Procon: ${valorProcon}`
            );

            // ✅ MAPEAR CADA TIPO DE CONTA PARA A CONSTANTE CORRESPONDENTE
            switch (contaTipo) {
              case "1.0. Pessoal":
                dadosMapeados[CONTA_PESSOAL] += valor;
                break;
              case "1.1. Pessoal Docente":
                dadosMapeados[CONTA_PESSOAL_DOCENTE] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 2
                if (idRelatorio) {
                  dadosPercentuais[2] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "1.2 Encargos Sociais Docentes":
                dadosMapeados[CONTA_ENCARGOS_DOCENTES] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 3
                if (idRelatorio) {
                  dadosPercentuais[3] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "1.3 Pessoal Técnico e Administrativo":
                dadosMapeados[CONTA_PESSOAL_ADMIN] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 4
                if (idRelatorio) {
                  dadosPercentuais[4] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "1.4 Encargos Sociais Administrativos":
                dadosMapeados[CONTA_ENCARGOS_ADMIN] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 5
                if (idRelatorio) {
                  dadosPercentuais[5] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.0 Despesas Gerais e Administrativas":
                dadosMapeados[CONTA_DESPESAS_GERAIS] += valor;
                break;
              case "2.1 Despesas com Material":
                dadosMapeados[CONTA_MATERIAL] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 7
                if (idRelatorio) {
                  dadosPercentuais[7] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.2 Conservação e Manutenção":
                dadosMapeados[CONTA_CONSERVACAO] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 8
                if (idRelatorio) {
                  dadosPercentuais[8] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.3 Serviços de Terceiros":
                dadosMapeados[CONTA_SERVICOS_TERCEIROS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 9
                if (idRelatorio) {
                  dadosPercentuais[9] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.4 Serviços Públicos":
                dadosMapeados[CONTA_SERVICOS_PUBLICOS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 10
                if (idRelatorio) {
                  dadosPercentuais[10] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.5 Imposto sobre serviços (ISS)":
                dadosMapeados[CONTA_ISS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 11
                if (idRelatorio) {
                  dadosPercentuais[11] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.6 Outras Despesas Tributárias":
                dadosMapeados[CONTA_OUTRAS_TRIBUTARIAS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 12
                if (idRelatorio) {
                  dadosPercentuais[12] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.7 Aluguéis":
                dadosMapeados[CONTA_ALUGUEIS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 13
                if (idRelatorio) {
                  dadosPercentuais[13] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.8 Depreciação":
                dadosMapeados[CONTA_DEPRECIACAO] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 14
                if (idRelatorio) {
                  dadosPercentuais[14] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "2.9 Outras Despesas":
                dadosMapeados[CONTA_OUTRAS_DESPESAS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 15
                if (idRelatorio) {
                  dadosPercentuais[15] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "4.0 Pró-Labore":
                dadosMapeados[CONTA_PRO_LABORE] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 17
                if (idRelatorio) {
                  dadosPercentuais[17] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "5.0 Valor Locativo":
                dadosMapeados[CONTA_VALOR_LOCATIVO] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 18
                if (idRelatorio) {
                  dadosPercentuais[18] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "7.0 Contribuições Sociais":
                dadosMapeados[CONTA_CONTRIB_SOCIAIS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 20
                if (idRelatorio) {
                  dadosPercentuais[20] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "7.1 PIS/PASEP":
                dadosMapeados[CONTA_PIS_PASEP] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 21
                if (idRelatorio) {
                  dadosPercentuais[21] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "7.2 COFINS":
                dadosMapeados[CONTA_COFINS] += valor;
                // ✅ MAPEAR PERCENTUAL E ID PARA ITEM ID 22
                if (idRelatorio) {
                  dadosPercentuais[22] = {
                    idRelatorio,
                    percentualAjus,
                    valorProcon,
                    baseValue: valor,
                  };
                }
                break;
              case "Nº de funcionários:":
                dadosMapeados[CONTA_NUM_FUNCIONARIOS] =
                  parseInt(valorFunc) || 0;
                break;
              case "Nº de professores:":
                dadosMapeados[CONTA_NUM_PROFESSORES] = parseInt(valorFunc) || 0;
                break;
              case "Carga horária total anual:":
                dadosMapeados[CONTA_CARGA_HORARIA] = parseFloat(valorFunc) || 0;
                break;
              case "Faturamento Total em R$":
                dadosMapeados[CONTA_FATURAMENTO_TOTAL] =
                  parseFloat(valorFunc) || 0;
                break;
              case "Número de alunos pagantes":
                dadosMapeados[CONTA_ALUNOS_PAGANTES] =
                  parseInt(valorProcon) || 0;
                // ✅ CAPTURAR ID PARA O INDICADOR GLOBAL
                if (idRelatorio) {
                  dadosIndicadoresIds.alunosPagantesId = idRelatorio;
                }
                break;
              case "Número de alunos não pagantes":
                dadosMapeados[CONTA_ALUNOS_NAO_PAGANTES] =
                  parseInt(valorProcon) || 0;
                // ✅ CAPTURAR ID PARA O INDICADOR GLOBAL
                if (idRelatorio) {
                  dadosIndicadoresIds.alunosNaoPagantesId = idRelatorio;
                }
                break;
              case "Valor da última mensalidade do ano-base":
                dadosMapeados[CONTA_ULTIMA_MENSALIDADE] =
                  parseFloat(valorProcon) || 0;
                // ✅ CAPTURAR ID PARA O INDICADOR GLOBAL
                if (idRelatorio) {
                  dadosIndicadoresIds.ultimaMensalidadeId = idRelatorio;
                }
                break;
              case "Valor da mensalidade após o reajuste proposto em __/__/___.":
                dadosMapeados[CONTA_MENSALIDADE_REAJUSTE] =
                  parseFloat(valorProcon) || 0;
                // ✅ CAPTURAR ID PARA O INDICADOR GLOBAL
                if (idRelatorio) {
                  dadosIndicadoresIds.mensalidadeReajusteId = idRelatorio;
                }
                break;
              case "Local":
                dadosMapeados[CONTA_LOCAL] = item.VALORCALCULO || "";
                break;
              case "Data":
                dadosMapeados[CONTA_DATA] = item.VALORCALCULO || "";
                break;
            }
          });

          console.log("✅ Dados mapeados do banco:", dadosMapeados);
          console.log("✅ Dados de percentuais mapeados:", dadosPercentuais);
          console.log(
            "✅ Dados de IDs dos indicadores globais:",
            dadosIndicadoresIds
          );

          // ✅ ATUALIZAR TODOS OS ESTADOS COM DADOS REAIS
          setDadosProcon(dadosMapeados);

          // ✅ ATUALIZAR INDICADORES GLOBAIS
          setIndicadoresGlobais((prev) => ({
            ...prev,
            numFuncionarios: dadosMapeados[CONTA_NUM_FUNCIONARIOS] || 0,
            numProfessores: dadosMapeados[CONTA_NUM_PROFESSORES] || 0,
            cargaHoraria: dadosMapeados[CONTA_CARGA_HORARIA] || 0,
            faturamentoBase: dadosMapeados[CONTA_FATURAMENTO_TOTAL] || 0,
            faturamentoAplicado:
              (dadosMapeados[CONTA_FATURAMENTO_TOTAL] || 0) *
              prev.faturamentoReajuste,
            // ✅ NOVOS CAMPOS ATUALIZADOS
            alunosPagantes: dadosMapeados[CONTA_ALUNOS_PAGANTES] || 0,
            alunosNaoPagantes: dadosMapeados[CONTA_ALUNOS_NAO_PAGANTES] || 0,
            ultimaMensalidade: dadosMapeados[CONTA_ULTIMA_MENSALIDADE] || 0,
            mensalidadeReajuste: dadosMapeados[CONTA_MENSALIDADE_REAJUSTE] || 0,
            local: dadosMapeados[CONTA_LOCAL] || "",
            data: dadosMapeados[CONTA_DATA] || "",
            // ✅ ADICIONAR OS IDS DOS RELATÓRIOS
            alunosPagantesId: dadosIndicadoresIds.alunosPagantesId || null,
            alunosNaoPagantesId:
              dadosIndicadoresIds.alunosNaoPagantesId || null,
            ultimaMensalidadeId:
              dadosIndicadoresIds.ultimaMensalidadeId || null,
            mensalidadeReajusteId:
              dadosIndicadoresIds.mensalidadeReajusteId || null,
          }));

          // ✅ ATUALIZAR DESPESAS COM DADOS REAIS E PERCENTUAIS SALVOS
          setDespesas((prev) =>
            prev.map((item) => {
              let newBaseValue = 0;

              switch (item.grupo) {
                case "1.1":
                  newBaseValue = dadosMapeados[CONTA_PESSOAL_DOCENTE] || 0;
                  break;
                case "1.2":
                  newBaseValue = dadosMapeados[CONTA_ENCARGOS_DOCENTES] || 0;
                  break;
                case "1.3":
                  newBaseValue = dadosMapeados[CONTA_PESSOAL_ADMIN] || 0;
                  break;
                case "1.4":
                  newBaseValue = dadosMapeados[CONTA_ENCARGOS_ADMIN] || 0;
                  break;
                case "2.1":
                  newBaseValue = dadosMapeados[CONTA_MATERIAL] || 0;
                  break;
                case "2.2":
                  newBaseValue = dadosMapeados[CONTA_CONSERVACAO] || 0;
                  break;
                case "2.3":
                  newBaseValue = dadosMapeados[CONTA_SERVICOS_TERCEIROS] || 0;
                  break;
                case "2.4":
                  newBaseValue = dadosMapeados[CONTA_SERVICOS_PUBLICOS] || 0;
                  break;
                case "2.5":
                  newBaseValue = dadosMapeados[CONTA_ISS] || 0;
                  break;
                case "2.6":
                  newBaseValue = dadosMapeados[CONTA_OUTRAS_TRIBUTARIAS] || 0;
                  break;
                case "2.7":
                  newBaseValue = dadosMapeados[CONTA_ALUGUEIS] || 0;
                  break;
                case "2.8":
                  newBaseValue = dadosMapeados[CONTA_DEPRECIACAO] || 0;
                  break;
                case "2.9":
                  newBaseValue = dadosMapeados[CONTA_OUTRAS_DESPESAS] || 0;
                  break;
              }

              // ✅ VERIFICAR SE EXISTE DADOS SALVOS PARA ESTE ITEM
              const dadosSalvos = dadosPercentuais[item.id];

              return {
                ...item,
                baseValue: newBaseValue,
                // ✅ USAR PERCENTUAL SALVO OU 0
                adjustmentPercent: dadosSalvos ? dadosSalvos.percentualAjus : 0,
                // ✅ USAR VALOR SALVO OU CALCULAR BASEADO NO BASE VALUE
                appliedValue: dadosSalvos
                  ? dadosSalvos.valorProcon
                  : newBaseValue,
                // ✅ ADICIONAR ID DO RELATÓRIO PARA FUTURAS ATUALIZAÇÕES
                idRelatorio: dadosSalvos ? dadosSalvos.idRelatorio : null,
              };
            })
          );

          // ✅ ATUALIZAR OUTROS CUSTOS COM DADOS REAIS E PERCENTUAIS SALVOS
          setOutrosCustos((prev) =>
            prev.map((item) => {
              let newBaseValue = 0;

              switch (item.grupo) {
                case "4.0":
                  newBaseValue = dadosMapeados[CONTA_PRO_LABORE] || 0;
                  break;
                case "5.0":
                  newBaseValue = dadosMapeados[CONTA_VALOR_LOCATIVO] || 0;
                  break;
                case "7.0":
                  newBaseValue = dadosMapeados[CONTA_CONTRIB_SOCIAIS] || 0;
                  break;
                case "7.1":
                  newBaseValue = dadosMapeados[CONTA_PIS_PASEP] || 0;
                  break;
                case "7.2":
                  newBaseValue = dadosMapeados[CONTA_COFINS] || 0;
                  break;
              }

              // ✅ VERIFICAR SE EXISTE DADOS SALVOS PARA ESTE ITEM
              const dadosSalvos = dadosPercentuais[item.id];

              return {
                ...item,
                baseValue: newBaseValue,
                // ✅ USAR PERCENTUAL SALVO OU 0
                adjustmentPercent: dadosSalvos ? dadosSalvos.percentualAjus : 0,
                // ✅ USAR VALOR SALVO OU CALCULAR BASEADO NO BASE VALUE
                appliedValue:
                  item.isHeader || item.isSpecial
                    ? 0
                    : dadosSalvos
                    ? dadosSalvos.valorProcon
                    : newBaseValue,
                // ✅ ADICIONAR ID DO RELATÓRIO PARA FUTURAS ATUALIZAÇÕES
                idRelatorio: dadosSalvos ? dadosSalvos.idRelatorio : null,
              };
            })
          );
        } else {
          console.log("⚠️ Nenhum dado encontrado no banco");
          setDadosProcon({});
        }
      } catch (error) {
        console.error("❌ Erro ao carregar dados:", error);
        setDadosProcon({});
      } finally {
        setLoadingItensInvestimento(false);
      }
    },
    []
  );


// ✅ FUNÇÃO PARA INICIAR GERAÇÃO DO RELATÓRIO
  const iniciarGeracaoRelatorio = useCallback(
    (tipo, nome) => {
      // ✅ MENSAGENS MOTIVACIONAIS PARA O LOADING
      const mensagensMotivacionais = [
        "📊 Compilando dados financeiros...",
        "🔍 Analisando movimentações orçamentárias...",
        "📈 Processando informações gerenciais...",
        "💰 Consolidando valores por centro de custo...",
        "📋 Formatando relatório para visualização...",
        "🎯 Preparando insights para tomada de decisão...",
        "⚡ Otimizando dados para melhor performance...",
        "🔄 Sincronizando informações mais recentes...",
      ];

      setRelatorioLoading(true);
      setRelatorioTipo(tipo);
      setRelatorioNome(nome);
      setRelatorioProgresso(0);
      setRelatorioMensagem(mensagensMotivacionais[0]);
      setRelatorioResultado(null);

      // Simular progresso
      let progresso = 0;
      let mensagemIndex = 0;

      const intervalo = setInterval(() => {
        progresso += Math.random() * 15 + 5; // Incremento aleatório entre 5-20%
        mensagemIndex = Math.floor(
          (progresso / 100) * mensagensMotivacionais.length
        );

        if (progresso >= 95) {
          progresso = 95; // Não deixar chegar a 100% até terminar
          clearInterval(intervalo);
        }

        setRelatorioProgresso(Math.min(progresso, 95));
        setRelatorioMensagem(
          mensagensMotivacionais[
            Math.min(mensagemIndex, mensagensMotivacionais.length - 1)
          ]
        );
      }, 800);

      // Guardar o intervalo para limpeza
      setRelatorioInterval(intervalo);
    },
    []
  );

  // ✅ FUNÇÃO PARA FINALIZAR GERAÇÃO DO RELATÓRIO
  const finalizarGeracaoRelatorio = useCallback(
    (sucesso, mensagem) => {
      // Limpar intervalo se existir
      if (relatorioInterval) {
        clearInterval(relatorioInterval);
        setRelatorioInterval(null);
      }

      setRelatorioProgresso(100);
      setRelatorioMensagem(
        sucesso ? "✅ Relatório gerado com sucesso!" : "❌ Erro na geração"
      );
      setRelatorioResultado({ sucesso, mensagem });

      // Fechar modal após 2 segundos se sucesso, ou manter aberto se erro
      setTimeout(() => {
        if (sucesso) {
          fecharModalRelatorio();
        }
      }, 2000);
    },
    [relatorioInterval]
  );

  // ✅ FUNÇÃO PARA FECHAR MODAL DE RELATÓRIO
  const fecharModalRelatorio = useCallback(() => {
    if (relatorioInterval) {
      clearInterval(relatorioInterval);
      setRelatorioInterval(null);
    }

    setRelatorioLoading(false);
    setRelatorioTipo("");
    setRelatorioNome("");
    setRelatorioProgresso(0);
    setRelatorioMensagem("");
    setRelatorioResultado(null);
  }, [relatorioInterval]);






  return (
    <div
      className="container-fluid p-3"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <style jsx>{`
        .badge-hover {
          transition: all 0.2s ease-in-out;
          cursor: default;
        }
        .badge-hover:hover {
          transform: scale(1.05);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .input-editable {
          border: 2px solid #ffc107 !important;
          background-color: #fffbf0 !important;
        }
        .input-editable:focus {
          border-color: #ff8c00 !important;
          box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25) !important;
        }
        .campo-editavel {
          position: relative;
        }
        .campo-editavel::before {
          content: "✏️";
          position: absolute;
          top: -8px;
          right: -8px;
          font-size: 12px;
          z-index: 10;
        }
      `}</style>

      {/* Header Compacto */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card shadow-sm border-0">
            <div className="card-body py-2">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="bg-primary rounded p-2 me-2">
                    <Calculator className="text-white" size={16} />
                  </div>
                  <div>
                    <h6 className="mb-0">
                      <span className="text-success fw-bold">
                        Sistema de Orçamento
                      </span>{" "}
                      —
                      <span className="badge bg-success ms-1">
                        {localStorage.getItem("selectedYear")}{" "}
                      </span>
                      <span className="badge bg-info ms-1">
                        {localStorage.getItem("NomeFilial")}
                      </span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3">
        {/* Coluna Lateral - Parâmetros */}
        <div className="col-xl-3 col-lg-4">
          {/* Parâmetros de Lançamento */}
          <div className="card shadow-sm mb-3">
            <div className="card-header bg-dark text-white py-2">
              <h6 className="mb-0 fw-bold">
                <Settings className="me-2" size={16} />
                Lançamentos de Parâmetros (PCP)
              </h6>
            </div>
            <div className="card-body p-3">
              <div className="row g-2">
                <div className="col-12">
                  <label className="form-label small fw-semibold">
                    Centro Custo
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={centroCusto}
                    onChange={(e) => setCentroCusto(e.target.value)}
                  >
                    <option value="1.05.01.02.001">Educação Infantil</option>
                    <option value="1.05.01.02.002">Ensino Fundamental I</option>
                    <option value="1.05.01.02.003">
                      Ensino Fundamental II
                    </option>
                    <option value="1.05.01.02.004">Ensino Médio</option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label small fw-semibold">
                    % RATEIO GASTOS
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={rateioGastos}
                    onChange={(e) =>
                      setRateioGastos(parseFloat(e.target.value))
                    }
                    step="0.1"
                  />
                </div>
              </div>
              <button
                className="btn btn-danger btn-sm w-100 mt-3"
                onClick={ProconCriaDados}
                disabled={loading}
              >
                <Play className="me-1" size={14} />
                {loading ? "Atualizando..." : "Atualizar Valores Bases"}
              </button>
              <div className="alert alert-info border-0 mt-2 py-1">
                <small className="d-flex align-items-center">
                  <AlertCircle size={12} className="me-1" />
                  Os valores do "Ano Base" são atualizados por este botão.
                </small>
              </div>
              <div className="alert alert-warning border-0 mt-2 py-1">
                <small className="d-flex align-items-center">
                  <AlertCircle size={12} className="me-1" />
                  Esse processo pode levar alguns segundos.
                </small>
              </div>
            </div>
          </div>

          {/* Geração de Relatório */}
{/* Geração de Relatório */}
<div className="card shadow-sm mb-3">
  <div className="card-header bg-success text-white py-3">
    <h5 className="mb-0 fw-bold d-flex align-items-center">
      <FileText className="me-2" size={20} />
      Geração do Relatório (PDF)
    </h5>
  </div>
  <div className="card-body p-4">
    
    {/* Botão principal maior e mais destacado */}
        <div className="d-grid gap-2 mb-3">
          <BotaoRelatorio
            tipo="Procon"
            texto="Gerar Relatório Procon"
            icone="📄"
            formato="pdf"
            parametros={{
              pCODCOLIGADA: PpCODCOLIGADA,
              pCODFILIAL: PpCODFILIAL,
              pANO: PpANO,
              pCCUSTO: centroCusto,
            }}
            abrirEmModal={true}
            onStartGeneration={iniciarGeracaoRelatorio}
            onFinishGeneration={finalizarGeracaoRelatorio}
          />
        </div>

        {/* Alerta com mais destaque */}
            <div className="alert alert-warning border-0 d-flex align-items-start mb-0">
              <AlertCircle size={16} className="me-2 mt-1 flex-shrink-0" />
              <div>
                <small className="fw-semibold d-block mb-1">
                  {!dadosCarregados ? "⚠️ Atenção" : "ℹ️ Informação"}
                </small>
                <small>
                  {!dadosCarregados
                    ? "Primeiro atualize os valores base antes de gerar o relatório."
                    : "O processo de geração pode levar alguns segundos. Aguarde sem fechar esta janela."}
                </small>
              </div>
            </div>

          </div>
        </div>

          {/* Summary Cards Compactos */}
          {dadosCarregados && (
            <>
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <div className="card border-primary text-center">
                    <div className="card-body p-2">
                      <Users className="text-primary mb-1" size={16} />
                      <div className="small text-muted">Funcionários</div>
                      <div className="fw-bold text-primary">
                        {indicadoresGlobais.numFuncionarios}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card border-success text-center">
                    <div className="card-body p-2">
                      <Target className="text-success mb-1" size={16} />
                      <div className="small text-muted">Total Geral</div>
                      <div className="fw-bold text-success small">
                        R$ {formatCurrency(totalDespesas + totalOutrosCustos)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-2 mb-3">
                <div className="col-6">
                  <div className="card border-info text-center">
                    <div className="card-body p-2">
                      <Users className="text-info mb-1" size={16} />
                      <div className="small text-muted">Alunos Pagantes</div>
                      <div className="fw-bold text-info">
                        {indicadoresGlobais.alunosPagantes}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card border-warning text-center">
                    <div className="card-body p-2">
                      <DollarSign className="text-warning mb-1" size={16} />
                      <div className="small text-muted">Última Mensalidade</div>
                      <div className="fw-bold text-warning small">
                        R${" "}
                        {formatCurrency(indicadoresGlobais.ultimaMensalidade)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Mini Dashboard - Só aparece se dados carregados */}
          {dadosCarregados && (
            <div
              className="card shadow-sm border-warning bg-gradient mb-3"
              style={{
                background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
                border: "2px solid #ffc107",
              }}
            >
              <div className="card-header bg-warning text-dark py-2 text-center">
                <h6 className="mb-0 fw-bold">
                  <BarChart3 className="me-2" size={16} />
                  📊 DASHBOARD DE REAJUSTE
                </h6>
              </div>
              <div className="card-body p-2">
                <div className="row g-2 mb-2">
                  <div className="col-6">
                    <div className="card bg-primary text-white text-center">
                      <div className="card-body p-2">
                        <div className="small">💰 ANTES REAJUSTE</div>
                        <div className="fw-bold small">
                          R${" "}
                          {formatCurrency(
                            despesas.reduce(
                              (sum, item) =>
                                !item.isHeader ? sum + item.baseValue : sum,
                              0
                            ) +
                              outrosCustos.reduce(
                                (sum, item) =>
                                  !item.isHeader && !item.isSpecial
                                    ? sum + item.baseValue
                                    : sum,
                                0
                              )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="card bg-success text-white text-center">
                      <div className="card-body p-2">
                        <div className="small">📈 APÓS REAJUSTE</div>
                        <div className="fw-bold small">
                          R$ {formatCurrency(totalDespesas + totalOutrosCustos)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-2">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <small className="fw-bold">Impacto do Reajuste:</small>
                    <small className="badge bg-info">
                      {(() => {
                        const antes =
                          despesas.reduce(
                            (sum, item) =>
                              !item.isHeader ? sum + item.baseValue : sum,
                            0
                          ) +
                          outrosCustos.reduce(
                            (sum, item) =>
                              !item.isHeader && !item.isSpecial
                                ? sum + item.baseValue
                                : sum,
                            0
                          );
                        const depois = totalDespesas + totalOutrosCustos;
                        const percentImpact =
                          antes > 0 ? ((depois - antes) / antes) * 100 : 0;
                        return `+${percentImpact.toFixed(2)}%`;
                      })()}
                    </small>
                  </div>
                  <div className="progress" style={{ height: "8px" }}>
                    <div
                      className="progress-bar bg-success progress-bar-striped progress-bar-animated"
                      style={{
                        width: `${(() => {
                          const antes =
                            despesas.reduce(
                              (sum, item) =>
                                !item.isHeader ? sum + item.baseValue : sum,
                              0
                            ) +
                            outrosCustos.reduce(
                              (sum, item) =>
                                !item.isHeader && !item.isSpecial
                                  ? sum + item.baseValue
                                  : sum,
                              0
                            );
                          const depois = totalDespesas + totalOutrosCustos;
                          const percent =
                            antes > 0 ? ((depois - antes) / antes) * 100 : 0;
                          return Math.min(100, Math.max(5, percent * 2));
                        })()}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Coluna Principal - Tabelas */}
        <div className="col-xl-9 col-lg-8">
          {/* Indicadores Globais */}
          <div className="card shadow-sm mb-3">
            <div
              className="card-header bg-primary text-white py-2 cursor-pointer"
              onClick={() => toggleSection("indicadores")}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fw-bold">🏢 INDICADORES GLOBAIS</h6>
                {expandedSections.indicadores ? "🔼" : "🔽"}
              </div>
            </div>

            {expandedSections.indicadores && (
              <div className="card-body p-0">
                {!dadosCarregados ? (
                  <div className="text-center p-4">
                    ⚠️
                    <h6 className="text-muted">Nenhum dado carregado</h6>
                    <small className="text-muted">
                      Primeiro atualize os valores base para visualizar os
                      indicadores globais.
                    </small>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="fw-semibold">CONTAS</th>
                          <th className="text-center fw-semibold">ANO-BASE</th>
                          <th className="text-center fw-semibold">
                            % REAJUSTE P/
                          </th>
                          <th className="text-center fw-semibold">
                            ANO DE APLICAÇÃO (*)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              👥
                              <span className="fw-semibold small ms-2">
                                Nº de funcionários:
                              </span>
                            </div>
                          </td>
                          <td
                            className="text-center"
                            style={{ width: "150px" }}
                          >
                            <span className="badge bg-primary rounded-pill px-3 py-2 badge-hover">
                              {indicadoresGlobais.numFuncionarios}
                            </span>
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-primary bg-light p-1 rounded small">
                              {indicadoresGlobais.numFuncionarios}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              🎓
                              <span className="fw-semibold small ms-2">
                                Nº de professores:
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-info rounded-pill px-3 py-2 badge-hover">
                              {indicadoresGlobais.numProfessores}
                            </span>
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-primary bg-light p-1 rounded small">
                              {indicadoresGlobais.numProfessores}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              ⏰
                              <span className="fw-semibold small ms-2">
                                Carga horária total anual:
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-warning text-dark rounded-pill px-3 py-2 badge-hover">
                              {indicadoresGlobais.cargaHoraria}
                            </span>
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-primary bg-light p-1 rounded small">
                              {indicadoresGlobais.cargaHoraria}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              💰
                              <span className="fw-semibold small ms-2">
                                Faturamento Total em R$
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-secondary rounded-pill px-3 py-2 badge-hover">
                              R${" "}
                              {formatCurrency(
                                indicadoresGlobais.faturamentoBase
                              )}
                            </span>
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-success bg-light p-1 rounded small">
                              R${" "}
                              {formatCurrency(
                                indicadoresGlobais.faturamentoBase
                              )}
                            </div>
                          </td>
                        </tr>

                        {/* ✅ CAMPOS EDITÁVEIS PARA ALUNOS PAGANTES - AGORA USA updateIndicadorGlobal COM ID */}
                        <tr className="bg-warning bg-opacity-10">
                          <td>
                            <div className="d-flex align-items-center">
                              👥
                              <span className="fw-semibold small ms-2">
                                🔺 Número de alunos pagantes:
                              </span>
                              <span className="badge bg-warning text-dark ms-2 small">
                                EDITÁVEL
                              </span>
                            </div>
                          </td>
                          <td className="text-center campo-editavel">
                            <input
                              type="number"
                              className="form-control form-control-sm text-center input-editable"
                              value={indicadoresGlobais.alunosPagantes}
                              onChange={(e) =>
                                updateIndicadorGlobal(
                                  "alunosPagantes",
                                  parseInt(e.target.value) || 0
                                )
                              }
                              min="0"
                              placeholder="0"
                            />
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-success bg-light p-1 rounded small">
                              {indicadoresGlobais.alunosPagantes}
                            </div>
                          </td>
                        </tr>

                        {/* ✅ CAMPOS EDITÁVEIS PARA ALUNOS NÃO PAGANTES - AGORA USA updateIndicadorGlobal COM ID */}
                        <tr className="bg-warning bg-opacity-10">
                          <td>
                            <div className="d-flex align-items-center">
                              👥
                              <span className="fw-semibold small ms-2">
                                🔺 Número de alunos não pagantes:
                              </span>
                              <span className="badge bg-warning text-dark ms-2 small">
                                EDITÁVEL
                              </span>
                            </div>
                          </td>
                          <td className="text-center campo-editavel">
                            <input
                              type="number"
                              className="form-control form-control-sm text-center input-editable"
                              value={indicadoresGlobais.alunosNaoPagantes}
                              onChange={(e) =>
                                updateIndicadorGlobal(
                                  "alunosNaoPagantes",
                                  parseInt(e.target.value) || 0
                                )
                              }
                              min="0"
                              placeholder="0"
                            />
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-success bg-light p-1 rounded small">
                              {indicadoresGlobais.alunosNaoPagantes}
                            </div>
                          </td>
                        </tr>

                        {/* ✅ CAMPOS EDITÁVEIS PARA ÚLTIMA MENSALIDADE - AGORA USA updateIndicadorGlobal COM ID */}
                        <tr className="bg-warning bg-opacity-10">
                          <td>
                            <div className="d-flex align-items-center">
                              💰
                              <span className="fw-semibold small ms-2">
                                🔺 Valor da última mensalidade do ano-base:
                              </span>
                              <span className="badge bg-warning text-dark ms-2 small">
                                EDITÁVEL
                              </span>
                            </div>
                          </td>
                          <td className="text-center campo-editavel">
                            <input
                              type="number"
                              className="form-control form-control-sm text-center input-editable"
                              value={indicadoresGlobais.ultimaMensalidade}
                              onChange={(e) =>
                                updateIndicadorGlobal(
                                  "ultimaMensalidade",
                                  parseFloat(e.target.value) || 0
                                )
                              }
                              min="0"
                              step="0.01"
                              placeholder="0,00"
                            />
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-success bg-light p-1 rounded small">
                              R${" "}
                              {formatCurrency(
                                indicadoresGlobais.ultimaMensalidade
                              )}
                            </div>
                          </td>
                        </tr>

                        {/* ✅ CAMPOS EDITÁVEIS PARA MENSALIDADE APÓS REAJUSTE - AGORA USA updateIndicadorGlobal COM ID */}
                        <tr className="bg-warning bg-opacity-10">
                          <td>
                            <div className="d-flex align-items-center">
                              💰
                              <span className="fw-semibold small ms-2">
                                🔺 Valor da mensalidade após o reajuste
                                proposto:
                              </span>
                              <span className="badge bg-warning text-dark ms-2 small">
                                EDITÁVEL
                              </span>
                            </div>
                          </td>
                          <td className="text-center campo-editavel">
                            <input
                              type="number"
                              className="form-control form-control-sm text-center input-editable"
                              value={indicadoresGlobais.mensalidadeReajuste}
                              onChange={(e) =>
                                updateIndicadorGlobal(
                                  "mensalidadeReajuste",
                                  parseFloat(e.target.value) || 0
                                )
                              }
                              min="0"
                              step="0.01"
                              placeholder="0,00"
                            />
                          </td>
                          <td className="text-center small text-muted">-</td>
                          <td className="text-center">
                            <div className="fw-bold text-success bg-light p-1 rounded small">
                              R${" "}
                              {formatCurrency(
                                indicadoresGlobais.mensalidadeReajuste
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Componentes de Custos - Despesas */}
          <div className="card shadow-sm mb-3">
            <div
              className="card-header bg-primary text-white py-2 cursor-pointer"
              onClick={() => toggleSection("despesas")}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <Calculator className="me-2" size={16} />
                  <h6 className="mb-0 fw-bold">
                    COMPONENTES DE CUSTOS (DESPESAS)
                  </h6>
                </div>
                {expandedSections.despesas ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                )}
              </div>
            </div>

            {expandedSections.despesas && (
              <div className="card-body p-0">
                {!dadosCarregados ? (
                  <div className="text-center p-4">
                    <AlertCircle className="text-muted mb-2" size={48} />
                    <h6 className="text-muted">Nenhum dado carregado</h6>
                    <small className="text-muted">
                      Primeiro atualize os valores base para visualizar as
                      despesas.
                    </small>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mb-0">
                      <thead className="bg-primary bg-opacity-10">
                        <tr>
                          <th className="fw-semibold">CONTAS</th>
                          <th className="text-center fw-semibold">ANO-BASE</th>
                          <th className="text-center fw-semibold">
                            % REAJUSTE P/
                          </th>
                          <th className="text-center fw-semibold">
                            ANO DE APLICAÇÃO (*)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {despesas.map((item, index) => (
                          <tr
                            key={item.id}
                            className={
                              item.isHeader
                                ? "bg-primary bg-opacity-20 fw-bold"
                                : index % 2 === 0
                                ? "bg-light bg-opacity-50"
                                : ""
                            }
                          >
                            <td>
                              <div className="d-flex align-items-center">
                                {item.grupo && (
                                  <span
                                    className="badge bg-secondary me-2"
                                    style={{ fontSize: "0.65rem" }}
                                  >
                                    {item.grupo}
                                  </span>
                                )}
                                {item.isHeader ? (
                                  <span className="fw-bold text-primary small">
                                    {item.description}
                                  </span>
                                ) : (
                                  <span className="fw-semibold small">
                                    {item.description}
                                    <span className="badge bg-warning text-dark ms-2 small">
                                      EDITÁVEL
                                    </span>
                                  </span>
                                )}
                              </div>
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {!item.isHeader ? (
                                <span
                                  className={`badge bg-${getBadgeColor(
                                    index,
                                    item.baseValue
                                  )} rounded-pill px-3 py-2 badge-hover ${
                                    getBadgeColor(index, item.baseValue) ===
                                    "warning"
                                      ? "text-dark"
                                      : item.baseValue === 0
                                      ? "text-white"
                                      : ""
                                  }`}
                                >
                                  R$ {formatCurrency(item.baseValue)}
                                </span>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "140px" }}
                            >
                              {!item.isHeader ? (
                                <div className="input-group input-group-sm">
                                  <input
                                    type="number"
                                    className="form-control form-control-sm text-center border-warning"
                                    value={item.adjustmentPercent}
                                    onChange={(e) =>
                                      updateDespesaPercent(
                                        item.id,
                                        parseFloat(e.target.value) || 0
                                      )
                                    }
                                    step="0.1"
                                    min="0"
                                    max="100"
                                  />
                                  <span className="input-group-text bg-warning text-dark">
                                    %
                                  </span>
                                </div>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {!item.isHeader ? (
                                <div className="fw-bold text-success bg-light p-1 rounded small">
                                  R$ {formatCurrency(item.appliedValue)}
                                </div>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Componentes de Custos - Outros Custos */}
          <div className="card shadow-sm">
            <div
              className="card-header bg-secondary text-white py-2 cursor-pointer"
              onClick={() => toggleSection("outrosCustos")}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <CreditCard className="me-2" size={16} />
                  <h6 className="mb-0 fw-bold">
                    COMPONENTES DE CUSTOS (OUTROS CUSTOS)
                  </h6>
                </div>
                {expandedSections.outrosCustos ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                )}
              </div>
            </div>

            {expandedSections.outrosCustos && (
              <div className="card-body p-0">
                {!dadosCarregados ? (
                  <div className="text-center p-4">
                    <AlertCircle className="text-muted mb-2" size={48} />
                    <h6 className="text-muted">Nenhum dado carregado</h6>
                    <small className="text-muted">
                      Primeiro atualize os valores base para visualizar os
                      outros custos.
                    </small>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mb-0">
                      <thead className="bg-secondary bg-opacity-10">
                        <tr>
                          <th className="fw-semibold">CONTAS</th>
                          <th className="text-center fw-semibold">ANO-BASE</th>
                          <th className="text-center fw-semibold">
                            % REAJUSTE P/
                          </th>
                          <th className="text-center fw-semibold">
                            ANO DE APLICAÇÃO (*)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {outrosCustos.map((item, index) => (
                          <tr
                            key={item.id}
                            className={
                              item.isHeader
                                ? "bg-secondary bg-opacity-20 fw-bold"
                                : index % 2 === 0
                                ? "bg-light bg-opacity-50"
                                : ""
                            }
                          >
                            <td>
                              <div className="d-flex align-items-center">
                                {item.grupo && (
                                  <span
                                    className="badge bg-secondary me-2"
                                    style={{ fontSize: "0.65rem" }}
                                  >
                                    {item.grupo}
                                  </span>
                                )}
                                {item.isHeader ? (
                                  <span className="fw-bold text-secondary small">
                                    {item.description}
                                  </span>
                                ) : (
                                  <span className="fw-semibold small">
                                    {item.description}
                                    <span className="badge bg-warning text-dark ms-2 small">
                                      EDITÁVEL
                                    </span>
                                  </span>
                                )}
                              </div>
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {!item.isHeader ? (
                                <span
                                  className={`badge bg-${getBadgeColor(
                                    index,
                                    item.baseValue
                                  )} rounded-pill px-3 py-2 badge-hover ${
                                    getBadgeColor(index, item.baseValue) ===
                                    "warning"
                                      ? "text-dark"
                                      : item.baseValue === 0
                                      ? "text-white"
                                      : ""
                                  }`}
                                >
                                  R$ {formatCurrency(item.baseValue)}
                                </span>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "140px" }}
                            >
                              {!item.isHeader ? (
                                <div className="input-group input-group-sm">
                                  <input
                                    type="number"
                                    className="form-control form-control-sm text-center border-warning"
                                    value={item.adjustmentPercent}
                                    onChange={(e) =>
                                      updateOutrosCustosPercent(
                                        item.id,
                                        parseFloat(e.target.value) || 0
                                      )
                                    }
                                    step="0.1"
                                    min="0"
                                    max="100"
                                  />
                                  <span className="input-group-text bg-warning text-dark">
                                    %
                                  </span>
                                </div>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                            <td
                              className="text-center"
                              style={{ width: "150px" }}
                            >
                              {!item.isHeader ? (
                                <div className="fw-bold text-success bg-light p-1 rounded small">
                                  R$ {formatCurrency(item.appliedValue)}
                                </div>
                              ) : (
                                <div className="text-muted small">-</div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

        {/* ✅ MODAL DE LOADING PARA RELATÓRIOS */}
        {relatorioLoading && (
          <div
            className="modal d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.8)", zIndex: 9999 }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header bg-primary text-white border-0">
                  <h5 className="modal-title d-flex align-items-center">
                    <div
                      className="spinner-grow spinner-grow-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    📊 Gerando Relatório {relatorioNome}
                  </h5>
                  {relatorioResultado && !relatorioResultado.sucesso && (
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={fecharModalRelatorio}
                    ></button>
                  )}
                </div>

                <div className="modal-body text-center py-4">
                  {/* Animação de Loading */}
                  <div className="mb-4">
                    <div className="position-relative d-inline-block">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                        style={{ width: "4rem", height: "4rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div
                        className="position-absolute top-50 start-50 translate-middle"
                        style={{ fontSize: "1.5rem" }}
                      >
                        📊
                      </div>
                    </div>
                  </div>

                  {/* Barra de Progresso */}
                  <div className="mb-3">
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className={`progress-bar progress-bar-striped progress-bar-animated ${
                          relatorioProgresso === 100
                            ? relatorioResultado?.sucesso
                              ? "bg-success"
                              : "bg-danger"
                            : "bg-primary"
                        }`}
                        role="progressbar"
                        style={{ width: `${relatorioProgresso}%` }}
                        aria-valuenow={relatorioProgresso}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <small className="text-muted">
                      {relatorioProgresso.toFixed(0)}% concluído
                    </small>
                  </div>

                  {/* Mensagem Status */}
                  <div className="mb-3">
                    <p className="mb-1 fw-medium text-primary">
                      {relatorioMensagem}
                    </p>
                    {relatorioResultado && (
                      <div
                        className={`alert ${
                          relatorioResultado.sucesso
                            ? "alert-success"
                            : "alert-danger"
                        } mt-3`}
                      >
                        {relatorioResultado.mensagem}
                      </div>
                    )}
                  </div>

                  {/* Dicas Motivacionais */}
                  {!relatorioResultado && (
                <div className="mt-4 p-3 bg-light rounded border-start border-4 border-success">
                  <h6 className="text-success mb-2 fw-bold">
                    💡 Sobre o Relatório Procon
                  </h6>
                  <small className="text-muted d-block mb-2">
                    <strong>O que é:</strong> Relatório específico para atendimento às exigências do PROCON (Programa de Proteção e Defesa do Consumidor).
                  </small>
                  <small className="text-muted d-block mb-2">
                    <strong>Finalidade:</strong> Demonstra de forma detalhada e transparente a execução orçamentária, custos operacionais e investimentos realizados pela instituição.
                  </small>
                  <small className="text-muted d-block">
                    <strong>Conteúdo:</strong> Inclui análises comparativas, variações percentuais, distribuição por centro de custo e indicadores de gestão financeira.
                  </small>
                  </div>
                )}

                  {/* Informações Técnicas */}
                  <div className="mt-3">
                    <small className="text-muted d-block">
                      🏢 Filial: {localStorage.getItem("NomeFilial") || "N/A"}
                    </small>
                    <small className="text-muted d-block">
                      📅 Período:{" "}
                      {localStorage.getItem("selectedYear") ||
                        new Date().getFullYear()}
                    </small>
                    <small className="text-muted d-block">
                      👤 Usuário: {localStorage.getItem("username") || "N/A"}
                    </small>
                  </div>
                </div>

                {/* Footer apenas para erros */}
                {relatorioResultado && !relatorioResultado.sucesso && (
                  <div className="modal-footer border-0">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={fecharModalRelatorio}
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        fecharModalRelatorio();
                        // Tentar novamente
                        setTimeout(() => {
                          if (relatorioTipo === "lancamentos-analitico") {
                            iniciarGeracaoRelatorio(
                              "lancamentos-analitico",
                              "Analítico"
                            );
                          } else {
                            iniciarGeracaoRelatorio(
                              "lancamentos-sintetico",
                              "Sintético"
                            );
                          }
                        }, 100);
                      }}
                    >
                      🔄 Tentar Novamente
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}



          </div>
        </div>
      </div>
    </div>
  );
};

export default SistemaOrcamento;
